<div class="walkthrough-step-container">
  <!-- CONTENT -->
  <div class="content">
    <h1 class="content-title header-title">
      Don't leave<br />your customers<br />hanging...<br />it's <span>not cool.</span>
    </h1>

    <br />
    <br />
    <p class="content-description-title">If an ETA has not been set on an order, you will notice this indicator.</p>
    <div class="alarmclockindicator">
      <ion-img class="alarm-clock" src="assets/images/alarmclock.svg"></ion-img>
      <ion-progress-bar class="{{ smsClass }}" value="{{ smsValue }}" type="determinate"></ion-progress-bar>
    </div>
    <p class="content-description">Keep your customers happy and coming back for more, by always setting your ETAs!</p>
  </div>

  <!-- ICON / BG -->
  <div class="background">
    <div class="message-box">
      <ion-img src="assets/images/walkthrough/hub-indicator-icon.svg"></ion-img>

      <p class="message-box-title">If the time expires, your customer will get sent the following SMS:</p>
      <p class="message-box-description">
        "Hi Customer, we have received your order for {{ accountTitle }}, there may be an issue. Please call 0412345678
        to confirm Pick up time."
      </p>
    </div>
  </div>
</div>
